import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output
} from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ICentroResultado } from '@app/modules/centro_resultado/model/centro_resultado.model';
import { ICliente } from '@app/modules/clientes/model/cliente.model';
import { ICondicaoPagamento } from '@app/modules/condicao-pagamento/models/condicao.model';
import { FastClientsComponent } from '@app/modules/fast-cadastro/components/fast-clients/fast-clients.component';
import { FastGrupoComponent } from '@app/modules/fast-cadastro/components/fast-grupo/fast-grupo.component';
import { IFormaPagamento } from '@app/modules/forma-pagamento/models/forma-pagamento.model';
import { IFornecedor } from '@app/modules/fornecedor/models/fornecedor.model';
import { IInstituicaoFinanceira } from '@app/modules/instituicoes-financeiras/model/instituicao.model';
import { INaturezaFinanceira } from '@app/modules/natureza_financeira/model/natureza_financeira.model';
import { IProduto } from '@app/modules/produto/model';
import { ISerieFiscal } from '@app/modules/serie-fiscal/model/serie_fiscal.model';
import { ITabelaPreco } from '@app/modules/tabelapreco/model';
import { IUnidade } from '@app/modules/unidade/model/unidade.model';
import { IVariacao } from '@app/modules/variacao-produtos/model/variacao.model';
import { Observable, of } from 'rxjs';
import { debounceTime, filter, map, mergeMap, tap } from 'rxjs/operators';
import {
  EntityService,
  IEntity,
  IRoute,
  TokenService,
  Utils
} from 'viggo-sistemas-core-web';
import { ICodigoSegContribuinte } from '../../../../shared/model/csc.model';
import { IFabricante } from '../../../fabricantes/models/fabricante.model';
import { RegraFiscal } from '../../../regra-fiscal/model/regra_fiscal.model';
import { ISupervisor } from '../../../supervisor/model/supervisor.model';
import { ITipoOperacao } from '../../../tipo_operacao/model/tipo_operacao.model';
import { IVendedor } from '../../../vendedor/model/vendedor.model';
import { FastCentroResultadoComponent } from '../fast-centro-resultado/fast-centro-resultado.component';
import { FastCondPgmtComponent } from '../fast-cond-pgmt/fast-cond-pgmt.component';
import { FastCodigoSegContribuinteComponent } from '../fast-csc/fast-csc.component';
import { FastFabricanteComponent } from '../fast-fabricante/fast-fabricante.component';
import { FastFormaPgmtComponent } from '../fast-forma-pgmt/fast-forma-pgmt.component';
import { FastFornecedorComponent } from '../fast-fornecedor/fast-fornecedor.component';
import { FastInstituicaoComponent } from '../fast-instituicao/fast-instituicao.component';
import { FastNaturezaFinanceiraComponent } from '../fast-natureza-financeira/fast-natureza-financeira.component';
import { FastProdutoComponent } from '../fast-produto/fast-produto.component';
import { FastRegraFiscalComponent } from '../fast-regra-fiscal/fast-regra-fiscal.component';
import { FastSerieFiscalComponent } from '../fast-serie-fiscal/fast-serie-fiscal.component';
import { FastSupervisorComponent } from '../fast-supervisor/fast-supervisor.component';
import { FastTabelaComponent } from '../fast-tabela/fast-tabela.component';
import { FastTipoOperacaoComponent } from '../fast-tipo-operacao/fast-tipo-operacao.component';
import { FastUnidadeComponent } from '../fast-unidade/fast-unidade.component';
import { FastVariacaoProdutoComponent } from '../fast-variacao-produto/fast-variacao-produto.component';
import { FastVendedorComponent } from '../fast-vendedor/fast-vendedor.component';

export type InsertType =
  | 'cliente'
  | 'cliente_fiscal'
  | 'vendedor'
  | 'fabricante'
  | 'supervisor'
  | 'grupo'
  | 'unidade'
  | 'fornecedor'
  | 'produto'
  | 'forma_pgmt'
  | 'condicao_pgmt'
  | 'tipo_operacao'
  | 'regra_fiscal'
  | 'regra_fiscal_pdv'
  | 'csc'
  | 'instituicao_financeira'
  | 'serie_fiscal'
  | 'serie_fiscal_prod'
  | 'serie_fiscal_homo'
  | 'centro_resultado'
  | 'natureza_financeira'
  | 'variacao_produto';

export const components: {
  [key: string]: { component: any; config: MatDialogConfig };
} = {
  cliente: {
    component: FastClientsComponent,
    config: {
      width: '800px',
      panelClass: ['dialog-sem-padding'],
      position: {
        top: '50px'
      },
      data: {
        usa_fiscal: false,
        entity: {
          parceiro: {
            enderecos: [],
            contatos: []
          }
        } as ICliente
      }
    }
  },
  cliente_fiscal: {
    component: FastClientsComponent,
    config: {
      width: '800px',
      panelClass: ['dialog-sem-padding'],
      position: {
        top: '50px'
      },
      data: {
        usa_fiscal: true,
        entity: {
          parceiro: {
            enderecos: [],
            contatos: []
          }
        } as ICliente
      }
    }
  },
  vendedor: {
    component: FastVendedorComponent,
    config: {
      width: '800px',
      panelClass: ['dialog-sem-padding'],
      position: {
        top: '50px'
      },
      data: {
        entity: {
          parceiro: {
            enderecos: [],
            contatos: []
          }
        } as IVendedor
      }
    }
  },
  fabricante: {
    component: FastFabricanteComponent,
    config: {
      width: '800px',
      panelClass: ['dialog-sem-padding'],
      position: {
        top: '50px'
      },
      data: {
        entity: {
          parceiro: {
            enderecos: [],
            contatos: []
          }
        } as IFabricante
      }
    }
  },
  supervisor: {
    component: FastSupervisorComponent,
    config: {
      width: '800px',
      panelClass: ['dialog-sem-padding'],
      position: {
        top: '50px'
      },
      data: {
        entity: {
          parceiro: {
            enderecos: [],
            contatos: []
          }
        } as ISupervisor
      }
    }
  },
  grupo: {
    component: FastGrupoComponent,
    config: {
      width: '400px',
      panelClass: ['dialog-sem-padding'],
      position: {
        top: '50px'
      },
      data: {
        is_parent: false
      }
    }
  },
  unidade: {
    component: FastUnidadeComponent,
    config: {
      width: '400px',
      panelClass: ['dialog-sem-padding'],
      position: {
        top: '50px'
      },
      data: {
        entity: {} as IUnidade
      }
    }
  },
  fornecedor: {
    component: FastFornecedorComponent,
    config: {
      width: '800px',
      panelClass: ['dialog-sem-padding'],
      position: {
        top: '50px'
      },
      data: {
        entity: {
          parceiro: {
            enderecos: [],
            contatos: []
          }
        } as IFornecedor
      }
    }
  },
  produto: {
    component: FastProdutoComponent,
    config: {
      width: '1000px',
      panelClass: ['dialog-sem-padding'],
      position: {
        top: '50px'
      },
      data: {
        entity: {} as IProduto
      }
    }
  },
  tabela_preco: {
    component: FastTabelaComponent,
    config: {
      width: '600px',
      panelClass: ['dialog-sem-padding'],
      position: {
        top: '50px'
      },
      data: {
        entity: {} as ITabelaPreco
      }
    }
  },
  forma_pgmt: {
    component: FastFormaPgmtComponent,
    config: {
      width: '600px',
      panelClass: ['dialog-sem-padding'],
      position: {
        top: '50px'
      },
      data: {
        entity: {} as IFormaPagamento
      }
    }
  },
  condicao_pgmt: {
    component: FastCondPgmtComponent,
    config: {
      width: '800px',
      panelClass: ['dialog-sem-padding'],
      position: {
        top: '50px'
      },
      data: {
        entity: {
          parcelas: []
        } as ICondicaoPagamento
      }
    }
  },
  tipo_operacao: {
    component: FastTipoOperacaoComponent,
    config: {
      width: '600px',
      panelClass: ['dialog-sem-padding'],
      position: {
        top: '50px'
      },
      data: {
        entity: {} as ITipoOperacao
      }
    }
  },
  regra_fiscal: {
    component: FastRegraFiscalComponent,
    config: {
      width: '800px',
      panelClass: ['dialog-sem-padding'],
      position: {
        top: '50px'
      },
      data: {
        entity: {} as RegraFiscal,
        pdv: false
      }
    }
  },
  regra_fiscal_pdv: {
    component: FastRegraFiscalComponent,
    config: {
      width: '800px',
      panelClass: ['dialog-sem-padding'],
      position: {
        top: '50px'
      },
      data: {
        entity: {} as RegraFiscal,
        pdv: true
      }
    }
  },
  csc: {
    component: FastCodigoSegContribuinteComponent,
    config: {
      width: '600px',
      panelClass: ['dialog-sem-padding'],
      position: {
        top: '50px'
      },
      data: {
        entity: {} as ICodigoSegContribuinte
      }
    }
  },
  instituicao_financeira: {
    component: FastInstituicaoComponent,
    config: {
      width: '600px',
      panelClass: ['dialog-sem-padding'],
      position: {
        top: '50px'
      },
      data: {
        entity: {} as IInstituicaoFinanceira
      }
    }
  },
  serie_fiscal: {
    component: FastSerieFiscalComponent,
    config: {
      width: '600px',
      panelClass: ['dialog-sem-padding'],
      position: {
        top: '50px'
      },
      data: {
        entity: ({
          modelo: 'NFCE'
        } as unknown) as ISerieFiscal
      }
    }
  },
  serie_fiscal_homo: {
    component: FastSerieFiscalComponent,
    config: {
      width: '600px',
      panelClass: ['dialog-sem-padding'],
      position: {
        top: '50px'
      },
      data: {
        entity: ({
          modelo: 'NFE',
          ambiente: 'HOMOLOGACAO'
        } as unknown) as ISerieFiscal
      }
    }
  },
  serie_fiscal_prod: {
    component: FastSerieFiscalComponent,
    config: {
      width: '600px',
      panelClass: ['dialog-sem-padding'],
      position: {
        top: '50px'
      },
      data: {
        entity: ({
          modelo: 'NFE',
          ambiente: 'PRODUCAO'
        } as unknown) as ISerieFiscal
      }
    }
  },
  centro_resultado: {
    component: FastCentroResultadoComponent,
    config: {
      width: '600px',
      panelClass: ['dialog-sem-padding'],
      position: {
        top: '50px'
      },
      data: {
        entity: {} as ICentroResultado
      }
    }
  },
  natureza_financeira: {
    component: FastNaturezaFinanceiraComponent,
    config: {
      width: '600px',
      panelClass: ['dialog-sem-padding'],
      position: {
        top: '50px'
      },
      data: {
        entity: {} as INaturezaFinanceira
      }
    }
  },
  variacao_produto: {
    component: FastVariacaoProdutoComponent,
    config: {
      width: '600px',
      panelClass: ['dialog-sem-padding'],
      position: {
        top: '50px'
      },
      data: {
        entity: {
          itens: []
        } as IVariacao
      }
    }
  }
};

@Component({
  selector: 'fast-autocomplete',
  templateUrl: './fast-autocomplete.component.html',
  styleUrls: ['./fast-autocomplete.component.scss']
})
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export class FastAutocompleteComponent<T extends IEntity = any>
  implements OnInit, OnChanges {
  @Input() routesAuthorization: IRoute[] = [];
  @Input() data: any = {};
  @Input() useToSearch = false;
  @Input() useChange = false;
  @Input() searchField = '';
  @Input() notSelected = false;

  @Input() insertType: InsertType | null = null;
  /**
   * Placeholder usado pelo input
   */
  @Input() placeholder = 'Digite aqui';
  /**
   * Exibe mensagem de erro, caso haja
   */
  @Input() errorMsg = '';
  /**
   * Mensagens de erro
   */
  @Input() messages: { [key: string]: string };

  @Input() displayField = 'id';

  @Input() displaySecondField = 'id';
  /**
   * Tipo de input do autocomplete
   */
  @Input() inputType = 'text';
  /**
   * Identifica se o campo é de preenchimento obrigatório
   */
  @Input() public readonly required = false;
  /**
   * Função para exibir os dados do autocomplete
   * @deprecated
   */
  @Input() displayWith: (obj: T) => string = obj => obj.toString();
  /**
   * O FormControl responsável por gerenciar o input
   * @required
   */
  @Input() control: UntypedFormControl;
  /**
   * Configuração de selecionar automaticamente o uncio resultado
   */

  @Input() public readonly autoFirst: boolean = true;
  /**
   * Inicia dados preenchido quando a busca for vazia
   */

  @Input() public readonly initDataWithEmpty: boolean = false;
  /**
   * EntityService usado para buscar os resultados
   * exibidos pelo autocomplete
   * @required
   */

  @Input() entityService: EntityService<T>;

  /**
   * Caso o usuario queira repassar sua própria função de busca
   * É possível atravês dessa props
   */
  @Input() public readonly searchFN: (
    value: string,
    include?: string[],
    order_by?: string,
    page?: number,
    page_size?: number
  ) => Observable<any> = null;

  /**
   * Caso o usuario queira repassar sua própria função de busca
   * É possível atravês dessa props
   */
  @Input() public openDialogAddEntity: () => void = null;

  /**
   * Função chamada sempre que há uma requisição a API
   * Implementa lógica caso seja nescessário filtar as entidades
   * vindas do banco de dados, ex: impedir auto relacionamento de entidades
   * @param entities entidades vindas da requisição
   * @tutorial rulesFilterEntities Cuidado com a perda de contexto do "this" use arrow functions
   * ou tenha certeza que o contexto chamado seja da sua classe externa com o bind.
   */
  @Input() rulesFilterEntities: (entities: T[]) => T[] = entities => entities;

  /**
   * Quando os resultados são carregados da api, este evento é acionado, repassando
   * os resultados retornados da api
   */
  @Output() public onLoadResults = new EventEmitter<T[]>();
  @Output() public clearSelection = new EventEmitter<boolean>();

  filteredEntities: T[] = [];

  /**
   * Id do dominio onde a infomação deve ser pesquisada
   */
  @Input() domain_id: string;

  @Input() domainPath = 'domain_id';

  @Input() searchFieldPath = 'domain_id';

  @Input() value_order: string;

  @Input() listOptions: string = 'ACTIVE_ONLY';

  @Input() listOptionsPath: string = 'list_options';

  @Input() orderByPath = 'order_by';

  @Input() pageValue: number;

  @Input() pagePath = 'page';

  @Input() pageSizeValue: number;

  @Input() pageSizePath = 'page_size';

  @Input() public readonly include: string[] = null;

  @Input() showDropDown = true;

  @Input() action_order: string;

  /**
   * Mostra a entidade selecionada
   * @param entity entidade a ser mostrada
   */
  @Input() displayWithEntityFn = (entity: T | string) => {
    if (!entity) return '';
    if (typeof entity === 'string') return entity;
    return entity[this.displayField];
  };
  @Output() onSelect = new EventEmitter<T>();

  /**
   * É possivel repassar paremetros adicionais para a requisição
   */
  @Input() params: { [param: string]: string } = {};
  /**
   * Caso o usuario queira ter controle total sobre a montagem de paramentros adicionais, é possivel
   * repassar uma funcao que deve retornar uma string formatada com query params que serão inseridos
   * antes da requisção ser feita
   */
  @Input() buildParams: () => string = this.prepareParams;

  @Input() readonly = false;

  @Input() readonly interceptorService: EntityService<T> | null = null;

  @Input() interceptorPath = 'id';

  @Input() interceptorDomainPath = 'domain_id';

  @Input() actionState = true;

  @Input() showBtnDialog = false;

  @Input() controlIsEnabled = true;

  @Input() btnIcon = 'search';

  @Input() anotherDirection = false;

  @Input() public readonly interceptorInclude: string[] = null;

  /**
   * Emite eventos sempre que o autocomplete
   * precisar forçar a seleção de uma entidade
   * @description Emite o evento quando a entidade é selecionada
   */
  @Output() autoSelect: EventEmitter<T> = new EventEmitter();
  @Output() selectEntity: EventEmitter<T> = new EventEmitter();
  @Output() blur: EventEmitter<FocusEvent> = new EventEmitter();
  @Output() openDialog: EventEmitter<boolean> = new EventEmitter();

  public notShowOptions = false;
  public isLoading = false;
  public noResults = false;
  public isEmpty = false;

  constructor(
    protected tokenService: TokenService,
    public matDialog: MatDialog
  ) {
    this.buildParams = this.prepareParams;
  }

  protected getSearchField = (searchFieldPath = this.searchFieldPath) =>
    this.searchField || this.searchField === null
      ? `&${searchFieldPath}=${this.searchField}`
      : '';

  protected getDomain = (domainPath = this.domainPath) =>
    this.domainId ? `&${domainPath}=${this.domainId}` : '';

  protected getListOptions = (listOptionsPath = this.listOptionsPath) =>
    this.listOptions ? `&${listOptionsPath}=${this.listOptions}` : '';

  protected getOrderBy = (orderByPath = this.orderByPath) =>
    this.value_order ? `&${orderByPath}=${this.value_order}` : '';

  protected getPage = (pagePath = this.pagePath) =>
    this.pageValue ? `&${pagePath}=${this.pageValue}` : '';

  protected getPageSize = (pageSizePath = this.pageSizePath) =>
    this.pageSizeValue ? `&${pageSizePath}=${this.pageSizeValue}` : '';

  protected getInclude = (include = this.include) =>
    include ? this.getParamsByInclude(include) : '';

  protected getAnotherDirection = () =>
    this.anotherDirection ? `&anotherDirection=${this.anotherDirection}` : '';

  protected interceptFn = () => {
    if (this.interceptorService) {
      return mergeMap((entity: any) => {
        return this.interceptorService
          .getEntitiesByParams(
            `${this.getDomain(this.interceptorDomainPath)}${this.getInclude(
              this.interceptorInclude
            )}`
          )
          .pipe(
            map(interceptorEntities => {
              return interceptorEntities.data.reduce((acc, crr) => {
                return entity.data.filter(
                  p =>
                    Utils.getDescendantProp(p, this.interceptorPath) ===
                    Utils.getDescendantProp(crr, this.interceptorPath)
                ).length > 0
                  ? [...acc, crr]
                  : acc;
              }, []);
            })
          );
      });
    }
    return map((entity: any) => entity.data);
  };

  ngOnChanges() {
    if (this.searchField) this.searchField = this.searchField;
    if (this.notSelected) this.notSelected = this.notSelected;
    if (this.useChange) {
      if (!this.control.value) this.control.reset();
      if (this.initDataWithEmpty) {
        if (this.searchFN) {
          this.searchFN(
            '',
            this.include,
            this.value_order,
            this.pageValue,
            this.pageSizeValue
          ).subscribe(entities => {
            this.isLoading = false;
            if (this.action_order)
              this.filteredEntities = this.orderByResult(
                entities,
                this.action_order
              );
            else this.filteredEntities = entities;
          });
        } else {
          this.entityService
            .getEntitiesByParams(
              `${this.getAnotherDirection()}${this.getDomain()}${this.getListOptions()}${this.getSearchField()}${this.getInclude()}${this.getOrderBy()}${this.getPage()}${this.getPageSize()}`,
              undefined,
              true
            )
            .pipe(
              map(entities => this.rulesFilterEntities(entities)),
              tap(entities => {
                this.noResults = entities.data.length === 0;
              }),
              this.interceptFn()
            )
            .subscribe(entities => {
              this.isLoading = false;
              if (this.action_order)
                this.filteredEntities = this.orderByResult(
                  entities,
                  this.action_order
                );
              else this.filteredEntities = entities;
            });
        }
      }
    }
  }

  ngOnInit() {
    this.validateInputs();
    if (this.initDataWithEmpty && !this.useChange) {
      if (this.searchFN) {
        this.searchFN(
          '',
          this.include,
          this.value_order,
          this.pageValue,
          this.pageSizeValue
        ).subscribe(entities => {
          this.isLoading = false;
          if (this.action_order)
            this.filteredEntities = this.orderByResult(
              entities.data,
              this.action_order
            );
          else this.filteredEntities = entities.data;
        });
      } else {
        this.entityService
          .getEntitiesByParams(
            `${this.getAnotherDirection()}${this.getDomain()}${this.getListOptions()}${this.getSearchField()}${this.getInclude()}${this.getOrderBy()}${this.getPage()}${this.getPageSize()}`,
            undefined,
            true
          )
          .pipe(
            map(entities => this.rulesFilterEntities(entities)),
            tap(entities => {
              this.noResults = entities.data.length === 0;
            }),
            this.interceptFn()
          )
          .subscribe(entities => {
            this.isLoading = false;
            if (this.action_order)
              this.filteredEntities = this.orderByResult(
                entities,
                this.action_order
              );
            else this.filteredEntities = entities;
          });
      }
    }
    this.control.valueChanges
      .pipe(
        debounceTime(300),
        filter(() => {
          if (this.control.value === null) {
            this.control.setValue('');
            return typeof this.control.value === 'string';
          }
          // caso o valor selecionado seja um objeto, ele não faz uma requisição ao banco
          else if (typeof this.control.value === 'object' && !this.notSelected)
            this.selectEntity.emit(this.control.value);
          return typeof this.control.value === 'string';
        }),
        tap(() => {
          // this.isLoading = true;
          this.noResults = false;
          this.notShowOptions = false;
        }),
        mergeMap(text => {
          if (text && text !== '') {
            if (!text.replace(/\s/g, '').length) {
              this.isEmpty = true;
              return of([]);
            }
            this.isEmpty = false;
            var textFilter: any;
            if (this.insertType === 'produto') {
              this.displayField =
                text && text.length < 8 && /^\d+$/.test(text)
                  ? 'codigo'
                  : text && text.length >= 8 && /^\d+$/.test(text)
                  ? 'codigo_barra'
                  : 'descricao';
              textFilter =
                text && text.length < 8 && /^\d+$/.test(text)
                  ? Number(text)
                  : text && text.length >= 8 && /^\d+$/.test(text)
                  ? text + '%'
                  : text.trim() + '%';
            } else textFilter = text.trim() + '%';
            if (this.searchFN)
              return this.searchFN(
                textFilter,
                this.include,
                this.value_order,
                this.pageValue,
                this.pageSizeValue
              );
            const anotherParams = this.buildParams();

            // SOMENTE NUMERO (/^\d+$/.test(text))
            // SOMENTE LETRAS E NUMEROS (/^\d+$/.test(text))
            // CONTEM ESPAÇO (/^\d+$/.test(text))
            // CONTEM CPF (/^\d{3}\.\d{3}\.\d{3}\-\d{2}$/.test(text))
            // CONTEM CNPJ (/^\d{2}\.\d{3}\.\d{3}\/\d{4}\-\d{2}$/.test(text))
            // CONTEM CARACTER ESPECIAL (/[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(text))

            let url = `${
              this.displayField
            }=${textFilter}${this.getAnotherDirection()}${this.getDomain()}${this.getSearchField()}${this.getInclude()}${this.getOrderBy()}${this.getPage()}${this.getPageSize()}`;
            if (
              (/^[A-Za-z0-9]*$/.test(textFilter) || /\s/g.test(textFilter)) &&
              this.displaySecondField !== 'id'
            ) {
              if (
                /^\d+$/.test(textFilter) &&
                this.displaySecondField !== 'id'
              ) {
                url = `${
                  this.displaySecondField
                }=${textFilter}${this.getAnotherDirection()}${this.getDomain()}${this.getSearchField()}${this.getInclude()}${this.getOrderBy()}${this.getPage()}${this.getPageSize()}`;
              } else {
                url = `${
                  this.displayField
                }=${textFilter}${this.getAnotherDirection()}${this.getDomain()}${this.getSearchField()}${this.getInclude()}${this.getOrderBy()}${this.getPage()}${this.getPageSize()}`;
              }
            }
            if (anotherParams) url += `&${anotherParams}`;
            return this.entityService.getEntitiesByParams(url, undefined, true);
          } else {
            if (this.initDataWithEmpty) {
              const textFilter = text ? text.trim() : text;
              this.isEmpty = false;
              if (this.searchFN)
                return this.searchFN(
                  textFilter,
                  this.include,
                  this.value_order,
                  this.pageValue,
                  this.pageSizeValue
                );
              return this.entityService.getEntitiesByParams(
                `${this.getAnotherDirection()}${this.getDomain()}${this.getListOptions()}${this.getInclude()}${this.getSearchField()}${this.getOrderBy()}${this.getPage()}${this.getPageSize()}`,
                undefined,
                true
              );
            } else {
              this.isEmpty = true;
              return of([]);
            }
          }
        })
      )
      .pipe(
        map(entities => this.rulesFilterEntities(entities)),
        tap(entities => {
          this.noResults = entities.length === 0;
        }),
        this.interceptFn()
      )
      .subscribe(entities => {
        this.isLoading = false;

        if (this.action_order)
          this.filteredEntities = this.isEmpty
            ? []
            : this.orderByResult(entities, this.action_order);
        else this.filteredEntities = this.isEmpty ? [] : entities;

        if (
          this.filteredEntities &&
          this.filteredEntities.length === 1 &&
          this.autoFirst
        ) {
          this.control.setValue(this.filteredEntities[0]);
          this.autoSelect.emit(this.filteredEntities[0]);
          this.onSelect.emit(this.filteredEntities[0]);
        }
      });
  }

  orderByResult(results: any[], orderBy: any): any[] {
    return results.sort(function(a, b) {
      return Number(a[`${orderBy}`]) > Number(b[`${orderBy}`])
        ? 1
        : Number(b[`${orderBy}`]) > Number(a[`${orderBy}`])
        ? -1
        : 0;
    });
  }

  /**
   * Monta os paramentros adicionais a serem inseridos a request
   */
  private prepareParams(): string {
    if (!this.params) return '';
    const { params } = this;
    return Object.keys(params)
      .filter(key => params[key])
      .map(key => `${key}=${params[key]}`)
      .join('&');
  }
  private validateInputs() {
    if (!this.entityService && !this.searchFN) {
      throw new Error('EntityService or seach FN is required');
    }
    if (!this.control) {
      throw new Error('Formcontrol is required');
    }
  }
  /**
   * Pesquisa por uma entidade com base em um texto
   * @param value valor a ser buscao
   */
  protected getResults(value: string): Observable<T[]> {
    const anotherParams = this.buildParams();
    let url = `${
      this.displayField
    }=${value}%${this.getOrderBy()}${this.getPage()}${this.getPageSize()}`;
    if (anotherParams) url += `&${anotherParams}`;
    return this.entityService.getEntitiesByParams(url, this.domain_id, true);
  }

  getParamsByInclude(includes: string[]): string {
    if (includes.length > 0) return `&include=${includes.join(',')}`;
    return '';
  }
  getKey(): string {
    return Object.keys(this.control.errors)[0];
  }

  get domainId(): string {
    if (this.domain_id) return this.domain_id;
    else if (this.domain_id === undefined) return;
    else return this.tokenService.getDomain().id;
  }

  openDialogFast(): void {
    if (this.insertType) {
      this.matDialog
        .open(components[this.insertType].component, {
          ...components[this.insertType].config,
          disableClose: true,
          panelClass: components[this.insertType].config.panelClass,
          position: components[this.insertType].config.position,
          data: {
            ...components[this.insertType].config.data,
            ...this.data
          }
        })
        .afterClosed()
        .subscribe(componentEntity => {
          this.notShowOptions = false;
          if (componentEntity) {
            this.control.setValue(componentEntity);
            this.filteredEntities = [componentEntity, ...this.filteredEntities];
          } else {
            this.control.setValue(null);
          }
        });
    }
  }

  clearSelectValue() {
    this.notShowOptions = true;
    this.clearSelection.emit(true);
  }

  dialogClick() {
    this.notShowOptions = true;
    this.openDialog.emit(true);
  }
}
